import { Card } from '@ps/sports-ui-component-library';
import type { CompetitionId } from '@ps/web-sports-api-types';
import React from 'react';

import { ExpandablePanel, Menu, Title } from '@swf/sports/components';
import type { ExpandablePanelProps } from '@swf/sports/components/ExpandablePanel/ExpandablePanel';

import Competition from '../Competition/Competition';

export type Props = Omit<ExpandablePanelProps, 'children' | 'title'> & {
  name: string;
  competitionIds: CompetitionId[];
};

const Group: React.FC<Props> = (props) => (
  <Card>
    <ExpandablePanel openInitially={props.openInitially} title={<Title>{props.name}</Title>}>
      <Menu>
        {props.competitionIds.map((competitionId) => (
          <Competition key={competitionId} competitionId={competitionId} />
        ))}
      </Menu>
    </ExpandablePanel>
  </Card>
);

export default Group;
